import { format } from 'date-fns'
import { useRef, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useParams, useSearchParams } from 'react-router-dom'

import CloseIcon from '@/assets/img/ico-close-popup.svg?react'
import SearchIcon from '@/assets/img/search.svg?react'
import useDebounce from '@/hooks/useDebounce'
import { useGetSearchMessagesQuery } from '@/services/chats/chats'

interface ChartSearchBarProps {
    searchAction: React.Dispatch<React.SetStateAction<boolean>>
}

const ChartSearchBar = ({ searchAction }: ChartSearchBarProps) => {
    const [searchParams, setSearchParams] = useSearchParams()
    const [currentPage, setCurrentPage] = useState(1)
    const [searchTerm, setSearchTerm] = useState('')
    const containerRef = useRef<HTMLUListElement | null>(null)
    const { id } = useParams()
    const [canFeth, setCanFetch] = useState(false)
    const { data, isLoading } = useGetSearchMessagesQuery(
        {
            chatId: String(id),
            query: `page=${currentPage}&limit=30&search=${searchTerm}`,
        },
        { skip: !id || !canFeth },
    )
    const pagination = data?.pagination
    const messages = data?.data || []

    const hasMore = currentPage < (data?.pagination?.maxPages || 0)

    const clickHandler = (id: number) => {
        setSearchParams((prev) => {
            prev.set('messageId', id.toString())
            return prev
        })
    }
    const debounse = useDebounce((value: string) => {
        setCurrentPage(1)
        setCanFetch(true)
        setSearchTerm(value)
    }, 300)
    const fetchMoreData = () => {
        setCurrentPage((prevPage) => prevPage + 1)
    }

    return (
        <aside className="chat-sidebar">
            <div className="chat-sidebar--header chat-sidebar--header-search">
                <div className="form-group input--sm input--icon-left flex-auto">
                    <div className="input-wrapper">
                        <span className="ico text-color-1">
                            <SearchIcon />
                        </span>
                        <input
                            className="input input--solid full-radius w-full"
                            type="text"
                            placeholder="Search Message..."
                            onChange={({ target }) => {
                                debounse(target.value)
                            }}
                        />
                    </div>
                </div>
                <button
                    className="btn btn--square btn--xs"
                    onClick={() => searchAction(false)}
                >
                    <span className="ico">
                        <CloseIcon />
                    </span>
                </button>
            </div>
            <div className="chat-sidebar--body h-full">
                <ul
                    className="list-chats"
                    ref={containerRef}
                    id="scrollableListSearch"
                    style={{
                        overflow: 'auto',
                        display: 'flex',
                    }}
                >
                    <InfiniteScroll
                        dataLength={messages.length}
                        next={fetchMoreData}
                        hasMore={hasMore}
                        scrollableTarget="scrollableListSearch"
                        loader={<></>}
                    >
                        {messages?.length > 0 &&
                            !isLoading &&
                            messages?.map((message) => (
                                <li key={message.id} className="chat-item">
                                    <button
                                        type="button"
                                        className="list-chats-message"
                                        onClick={() => clickHandler(message.id)}
                                    >
                                        <p>{message?.content}</p>
                                        <p className="message-send-time text--xs color-secondary-light">
                                            {format(
                                                message.createdAt,
                                                'dd MMM, yyyy HH:mm',
                                            )}
                                        </p>
                                    </button>
                                </li>
                            ))}
                        {messages.length === 0 && !isLoading && canFeth && (
                            <li className="chat-item">
                                <div className="list-chats-message text-center">
                                    <p>Messages not found</p>
                                </div>
                            </li>
                        )}
                        {messages.length === 0 && !canFeth && (
                            <li className="chat-item">
                                <div className="list-chats-message text-center">
                                    <p>Enter message to search</p>
                                </div>
                            </li>
                        )}
                    </InfiniteScroll>
                </ul>
            </div>
        </aside>
    )
}

export default ChartSearchBar
